import { gql } from '__generated__';
import { useTranslation } from 'react-i18next';

import { Gender } from '__generated__/graphql';
import { useNotifier } from '../../common/Notifications/NotificationProvider';
import UI from '../../common/UI';
import useMutation from '../../api/useMutation';
import useProject from '../useProject';
import useScroll from '../../common/useScroll';

export const EditFeaturesMutation = gql(`
  mutation EditFeatures($input: EditFeaturesInput!) {
    editFeatures(input: $input) {
      ...ProjectFields
    }
  }
`);

const EditFeaturesPage = () => {
  const { t } = useTranslation();
  const notifier = useNotifier();
  const project = useProject();
  const { scrollTo } = useScroll();

  const genderNeutral = project.genders.includes(Gender.neutral);

  const [editFeatures, { error }] = useMutation(
    EditFeaturesMutation, {
      refetchQueries: ['Session'],
      onCompleted: () => {
        notifier.success(t('notifications.features_saved'));
      },
      onError: () => {
        scrollTo('ProjectTab');
      },
    },
  );

  const toggleGenderNeutrality = () => {
    editFeatures({
      variables: {
        input: {
          project: {
            id: project.id,
          },
          gender_neutral: !genderNeutral,
        },
      },
    });
  };

  return (
    <UI.Container sc={{ compact: true, px: [0, 4] }}>
      <UI.GridContainer>
        <UI.Div>
          <UI.H3>
            {t('features')}
          </UI.H3>
          <UI.InputDescription sc={{ mt: 1 }}>
            {t('features_description')}
          </UI.InputDescription>
        </UI.Div>

        <UI.Form onSubmit={() => editFeatures()}>
          <UI.Card>
            <UI.FormGrid>
              <UI.ServerErrors error={error} />

              <UI.FormGrid sc={{ columns: '2fr 1fr', alignVertical: 'center' }}>
                <UI.Div sc={{ muted: !genderNeutral, pt: 0.25 }}>
                  <UI.InputLabel sc={{ mb: 0 }}>
                    {t('gender_neutral_feature')}
                  </UI.InputLabel>
                  {t('gender_neutral_description')}
                </UI.Div>

                <UI.Div sc={{ textAlign: 'right' }}>
                  <UI.Toggle
                    checked={genderNeutral}
                    onChange={() => toggleGenderNeutrality()}
                  />
                </UI.Div>
              </UI.FormGrid>
            </UI.FormGrid>
          </UI.Card>
        </UI.Form>
      </UI.GridContainer>
    </UI.Container>
  );
};

export default EditFeaturesPage;
